import { Sections as SharedSectionsInterface } from '@naturalcycles/shared'

export enum DefaultSections {
  intro = 'intro',
  goal = 'goal',
  cycle = 'cycle',
  cycleChanges = 'cycleChanges',
  routine = 'routine',
}

export type ClearblueSections = Exclude<DefaultSections, DefaultSections.routine>

export type Sections = Record<ClearblueSections | DefaultSections, number> & SharedSectionsInterface

export enum Breakpoint {
  goal = 'goal',
  birthControlMethod = 'birthControlMethod',
  sideEffects = 'sideEffects',
  conceiveTiming = 'conceiveTiming',
  hormonalBirthControlUsage = 'hormonalBirthControlUsage',
  hormonalBirthControlHowLong = 'hormonalBirthControlHowLong',
  medicalConditions = 'medicalConditions',
  periodTrackerUsage = 'periodTrackerUsage',
  cycleChanges = 'cycleChanges',
  whichWearable = 'whichWearable',
  sleepWearable = 'sleepWearable',
  eligibleAppleWatch = 'eligibleAppleWatch',
  nightSleep = 'nightSleep',
  feelingStressed = 'feelingStressed',

  // AB-351
  hesitations = 'hesitations',
  research = 'research',

  // AB-355 - Cycle insights
  cycleChangesMood = 'cycleChangesMood',
  cycleChangesSexDrive = 'cycleChangesSexDrive',
  cycleChangesPain = 'cycleChangesPain',
  cycleChangesCervicalMucus = 'cycleChangesCervicalMucus',
  cycleChangesSkin = 'cycleChangesSkin',
}
